import React, { useContext } from "react";
import { Route, Redirect } from "wouter";

import { AuthContext } from "contexts/AuthContext";

const PrivateRoute = ({ authed, ...rest }) => {
  const { loading } = useContext(AuthContext);

  if (loading) {
    return null;
  }

  if (!authed) {
    return <Redirect to="/" />;
  }

  return <Route {...rest} />;
};

export default PrivateRoute;
